import React from 'react';
import { gtmAttributesUpdateForgotPasswordEmailSentPage } from '../../../../utils/gtmVariables';
import useGTMEventsTracker from '../../../../hooks/useGTMEventsTracker';

const SentStep = () => {
  const gtmEventsTracker = useGTMEventsTracker();
  gtmEventsTracker(gtmAttributesUpdateForgotPasswordEmailSentPage);

  return (
    <div className="m-auto grid lg:flex lg:flex-col justify-center items-center px-5 py-12 md:px-[25%] lg:px-[32%]">
      <span className="text-left lg:text-center font-semibold mb-2 text-[1.4rem] leading-[2rem] pr-12 sm:pr-0">
        Enviamos um email para você
      </span>
      <p className="text-left lg:text-center mb-72 sm:text-sm max-[640px]:text-[0.77rem] max-[640px]:leading-5 max-[300px]:mb-4">
        Por favor, verifique a sua caixa de entrada e de spam. Abra o link que está no email e
        redefina a senha de acesso.
      </p>
    </div>
  );
};

export default SentStep;
